/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SamlUiLogoInfoParser = /* #__PURE__ */ parsers.object([
    ['url', codecString],
    ['width', codecNumber],
    ['height', codecNumber],
]);
export class SamlUiLogoInfo extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SamlUiLogoInfoParser.decode(input).map(res => new SamlUiLogoInfo(res));
    }
    static unsafeDecode(input) {
        return SamlUiLogoInfo.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SamlUiLogoInfoParser.encode(data);
    }
    static schema() {
        return SamlUiLogoInfoParser.schema();
    }
}
